import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
//import { ToastContainer } from 'react-toastify';
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";


import {LeadDataAPI, CallerAPI, LeadAssignCallerAPI, getDispositionAPI, BulkLeadReAssignCallerAPI} from "./../../../API/Team/LeadAPI";
//import Sidebar from "./../Common/Sidebar";
//import Header from "./../Common/Header";
//import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";
import "./../../../Public/css/leads_list.css";
import { errorMesg } from "../../Toaster";
import ReactSelect from 'react-select';
import { Modal, Button, Offcanvas } from 'react-bootstrap';



const Lead = () =>{

    const [leads, setLeads] = useState([]);
    const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [dispositions, setDispositions] = useState([]);       
    const [filteremail, setFilterEmail] = useState("");
    const [filtername, setFilterName] = useState("");
    const [callers, setCallers] = useState([]);
    const [isleadassign, setIsLeadAssign] = useState(false);
    const [stages, setStages] = useState([]);
    const [program, setPrograms] = useState([]);
    const [institute, setInstitutes] = useState([]);
    const [showcustomdates, setShowCustomDates] = useState(false);
    const [datefilteroption, setDateFilterOption] = useState("");
    const [startdate, setStartDate] = useState("");
    const [enddate, setEndDate] = useState("");
    const [filterstage, setFilterStage] = useState("");
    const [filterdisposition, setFilterDisposition] = useState("");
    const [filtercaller, setFilterCaller] = useState("");
    const [filterparentcaller, setFilterParentCaller] = useState("");
    const [filterprogram, setFilterProgram] = useState("");
    const [filterinstitute, setFilterInstitute] = useState("");
    const [filtercontact, setFilterContact] = useState("");
    const [filtersStored, setFiltersStored] = useState(null);
    const [sortby, setSortBy] = useState("");
    const [orderby, setOrderBy] = useState("");
    const [totalrecords, setTotalRecords] = useState(0);
    const [isleadfiltermodal, setIsLeadFilterModal] = useState(false);
    const [btnloader, setBtnLoader] = useState(false);
    const [multicallers, setMultiCallers] = useState([]);
    const [selectedcaller, setSelectedCaller] = useState([]);
    const [selectedcallervalues, setSelectedCallerValues] = useState([]);
    const [leadids, setLeadIDs] = useState([]);
    const [assignedstartdate, setAssignedStartDate] = useState(null);
    const [assignedenddate, setAssignedEndDate] = useState(null);
    const [sources, setSources] = useState([]);
    const [filtersource, setFilterSource] = useState([]);
    const [assignmenttype, setAssignmentType] = useState(null);

    const [filtersDraft, setFiltersDraft] = useState({ 
                                                    filterstage: [],
                                                    filterdisposition: [],
                                                    filterprogram: [],
                                                    filterinstitute: [],
                                                    filterdateoption: "",
                                                    filterstartdate: "",
                                                    filterenddate: "",
                                                    filtername: "",
                                                    filteremail: "",
                                                    filtercontact: "",
                                                    filtercaller: "",
                                                    filtersortby: "",
                                                    filtersortorder: "",
                                                    filterassignedstartdate: "",
                                                    filterassignedenddate: "",
                                                    filtersource: [],
                                                    filterassignmenttype: "",
                                                    filterparentcaller: ""
                                                });


    const perpagedata = 20;

    const assignmenttypelist = [    
                                    {
                                        value: "new",
                                        label: "Fresh Assignment"
                                    }, 
                                    {
                                        value: "reassign",
                                        label: "Reassigned"
                                    }
                                    
                                ]


    useEffect(() => {

        //if(showleads)
        //{
            CallerAPI(setCallers, setMultiCallers);
            LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setCallers, "", setIsLeadAssign, setTotalRecords, setSources);
        //}

    }, [isleadassign]);

    useEffect(() => {
    
        console.log("Step 1");

        /*if (!filtersStored)
        {
            console.log('Step 1.2');
            return;  
        }*/ 
                
        console.log("Step 2");
        const params = new URLSearchParams();
        
        
        if (filtersStored)
        {
            console.log("Step 3");
                
            Object.keys(filtersStored).forEach(key => {
                if (filtersStored[key]) {
                    params.append(key, filtersStored[key]);
                }
            });
        }

        console.log("Step 4");

        params.append("page", currentPage);
        params.append("per_page", perpagedata);
        console.log(">>>>>" + JSON.stringify(params));
        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setCallers, params, false, setTotalRecords, setSources);

    }, [filtersStored, currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

   

    const handleFilterLeadStatus = (e) =>{
        setFilterDisposition(e.target.value);
    }

    const handleFilterEmail =(e) =>{

        setFilterEmail(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filteremail: e.target.value
                        }));
    }

    const handleFilterStage = (selstages) =>{
        console.log('Filter Stage=====' + JSON.stringify(selstages));

        setFilterStage(selstages);

        if(selstages)
        {
            let stagevalue = selstages.map(sgdatalist => sgdatalist.value);

            console.log('Selected stage value======' + stagevalue);

            setFiltersDraft(prev => ({
                            ...prev,
                            filterstage: stagevalue
                        }));

            getDispositionAPI(stagevalue, setDispositions);
        }




    }

    const handleFilterDispositon = (seldisposition) =>{
        console.log("Filter Disposition====" + JSON.stringify(seldisposition));

        setFilterDisposition(seldisposition);

        if(seldisposition)
        {
            let dispositionval = seldisposition.map(dpdatalist => dpdatalist.value);

            setFiltersDraft(prev => ({
                                ...prev,
                                filterdisposition: dispositionval
                            }));
        }
    }

    const handleFilterProgram = (selprogram) =>{
        console.log('Filter program====' + JSON.stringify(selprogram));

        setFilterProgram(selprogram);

        if(selprogram)
        {
            let programvalue = selprogram.map(prgdatalist => prgdatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filterprogram: programvalue
                            }));
        }
    }

    const handleFilterInstitute = (selinstitute) =>{
        console.log('Filter institute====' + JSON.stringify(selinstitute));

        setFilterInstitute(selinstitute);

        if(selinstitute)
        {
            let institutevalue = selinstitute.map(instdatalist => instdatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filterinstitute: institutevalue
                            }));
        }
    }

    const handleFilterName = (e) =>{
        setFilterName(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtername: e.target.value
                        }));
    }

    const handleDateFilterOption = (e) =>{

        console.log(e.target.value);

        setDateFilterOption(e.target.value);

        if(e.target.value === 'customdate')
        {
            setShowCustomDates(true);

            setFiltersDraft(prev => ({
                            ...prev,
                            filterdateoption: e.target.value
                        }));
        }
        else
        {
            setShowCustomDates(false);
            setStartDate("");
            setEndDate("");

            setFiltersDraft(prev => ({
                            ...prev,
                            filterdateoption: e.target.value,
                            filterstartdate: "",
                            filterenddate: ""
                        }));
        }

        

        

    }

    const handleStartDate = (e) =>{
        setStartDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterstartdate: e.target.value
                        }));
    }

    const handleEndDate = (e) =>{
        setEndDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterenddate: e.target.value
                        }));
    }

    const handleFilterCaller = (selcaller) =>{
        console.log(selcaller);
        setFilterCaller(selcaller);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercaller: selcaller ? selcaller.value : ""
                        }));
    }

    const handleFilterParentCaller = (selparentcaller) =>{
        console.log(selparentcaller);
        setFilterParentCaller(selparentcaller);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterparentcaller: selparentcaller ? selparentcaller.value : ""
                        }));
    }

    const handleFilterContact = (e) =>{

        setFilterContact(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercontact: e.target.value
                        }));
    }

    const handleApplyFilter = () =>{

        console.log('Filter Name====' + filtername);
        console.log('Filter Email====' + filteremail);
        console.log('Filter Disposition====' + filterdisposition);
        console.log('Filter Assigned Start Date====' + assignedstartdate);
        console.log('Filter Assigned End Date====' + assignedenddate);

        setFiltersStored({
                            ...filtersDraft,
                            //page: 1
                        });

        setCurrentPage(1);

        setIsLeadFilterModal(false);
    }

    const handleResetFilter = (e) =>{

        setFilterStage("");
        setFilterDisposition("");
        setFilterProgram("");
        setFilterInstitute("");
        setDateFilterOption("");
        setStartDate("");
        setEndDate("");
        setFilterName("");
        setFilterEmail("");
        setFilterContact("");
        setFilterCaller("");
        setAssignedStartDate("");
        setAssignedEndDate("");
        setFilterSource("");
        setAssignmentType("");
        setFilterParentCaller("");
        
        setFiltersDraft({
                    filterstage: "",
                    filterdisposition: "",
                    filterprogram: "",
                    filterinstitute: "",
                    filterdateoption: "",
                    filterstartdate: "",
                    filterenddate: "",
                    filteremail: "",
                    filtername: "",
                    filtercontact: "",
                    filtercaller: "",
                    filterassignedstartdate: "",
                    filterassignedenddate: "",
                    filtersource: "",
                    filterassignmenttype: "",
                    filterparentcaller: ""
        });

        setFiltersStored(null);
        setCurrentPage(1);
        
        //LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, null);
        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setCallers, "", false, setTotalRecords, setSources);
    }

    const handleLeadAssign = (e, leadid) =>{
        
        console.log('caller id===' + e.target.value);
        console.log('Lead id===' + leadid);

        const callerid = e.target.value;

        const params = {
                        'callerid': callerid,
                        'leadid': leadid
                    };

        LeadAssignCallerAPI(params, setIsLeadAssign);
    }
    
    const handleLeadSort = (sortby, sortorder) =>{
        
        //const filterparams = new URLSearchParams();

        setSortBy(sortby);
        setOrderBy(sortorder);
        console.log('Step 7');
        const updatedFilters = {
            ...filtersDraft,
            filtersortby: sortby,
            filtersortorder: sortorder
        };
    
        setFiltersDraft(updatedFilters);
        setFiltersStored(updatedFilters);
    
        setCurrentPage(1);
        

    }

    const handleLeadFilterModal = () =>{
        setIsLeadFilterModal(!isleadfiltermodal);
    }

    const handleLeadFilterModalHide = () =>{
        setIsLeadFilterModal(false);
    }



    const handleLeadReassign = (e) =>{
        e.preventDefault();

        console.log('leadids====' + leadids);
        console.log('callers====' + JSON.stringify(selectedcaller));

        if(selectedcaller)
        {
            let callerdata = selectedcaller.map(callerlist => callerlist.value);

            if(leadids.length > 0)
            {
                console.log('caller id===' + callerdata);
                console.log('selected ids===' + leadids);

                const params = {
                                'callerid': callerdata,
                                'leadids': leadids
                            };

                BulkLeadReAssignCallerAPI(params, setIsLeadAssign, setLoading, setFiltersStored, setSelectedCaller, setLeadIDs);
            }
            else
            {
                errorMesg('Please select a lead to assign this caller');
                return;
            }
        }
        else
        {
            errorMesg('Please select a caller');
            return;
        }
    }

    const handleSelectedCallerName = (selcaller) =>{

        console.log('>>>' + JSON.stringify(selcaller));

        if(selcaller)
        {
            let callervalue = selcaller.map(datalist => datalist.value);
            setSelectedCallerValues(callervalue);

            setSelectedCaller(selcaller);
        }
    }

    const handleSelectAllLeads = () =>{

        if(leadids.length === leads.length)
        {
            setLeadIDs([]);
        }
        else
        {
            setLeadIDs(leads.map(item => item.id));
        }
    }

    const handleSelectLead = (lid) =>{
        if(leadids.includes(lid))
        {
            setLeadIDs(leadids.filter(item => item !== lid));
        }
        else
        {
            setLeadIDs([...leadids, lid]);
        }
    }

    const handleAssignedDateRange = (dates) => {

        console.log("Assigned Dates====" + dates);

        if(!dates || (!dates[0] && !dates[1]))
        {
            
            console.log("assigned false condition");
            setAssignedStartDate("");
            setAssignedEndDate("");

            setFiltersDraft(prev => ({
                                ...prev,
                                filterassignedstartdate: "",
                                filterassignedenddate: ""
                            }));
        }
        else
        {
            console.log("assigned true condition");

            const [startdate, enddate] = dates;

            setAssignedStartDate(startdate);
            setAssignedEndDate(enddate);

            setFiltersDraft(prev => ({
                                ...prev,
                                filterassignedstartdate: format(startdate, "yyyy-MM-dd"),
                                filterassignedenddate: format(enddate, "yyyy-MM-dd")
                            }));

        }

    }

    const handleFilterSource = (selsource) =>{
        console.log('Filter source====' + JSON.stringify(selsource));

        setFilterSource(selsource);

        if(selsource)
        {
            let sourcevalue = selsource.map(sourcedatalist => sourcedatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filtersource: sourcevalue
                            }));
        }
    }

    const handleFilterAssignmentType = (selassigntype) =>{

        setAssignmentType(selassigntype);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterassignmenttype: selassigntype ? selassigntype.value : ""
                        }));
    }


    return(
    <Layout>
        <div className="content">
            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Leads</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="right">
                        <div className="row crm-filter-row-top align-items-center">

                            <div className="col-md-6 mb-1 d-flex align-items-center">
                                <button className="btn btn-success me-2" onClick={handleLeadFilterModal}>
                                    <i className="ti ti-filter me-2"></i> Filter
                                </button>

                                <button type="button" className="btn btn-dark" onClick={handleResetFilter}>
                                    <i className="fa fa-undo me-2"></i>Clear Filter
                                </button>
                            </div>

                            <div className="col-md-6 mb-1 d-flex justify-content-end align-items-center">
                                <div className="crm-caller-filter me-2">

                                    <ReactSelect className="me-1" value={selectedcaller} onChange={handleSelectedCallerName} options={multicallers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller" isMulti></ReactSelect>

                                </div>

                                <div class="crm-filter-actions">
                                    <button type="button" className="btn btn-primary"  onClick={handleLeadReassign}>
                                        {btnloader ?
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        :
                                            <p>Assign Lead</p>
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <Offcanvas show={isleadfiltermodal} onHide={handleLeadFilterModalHide} placement="end" className="offcanvas-custom">
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title id="contained-modal-title-vcenter">Filter Leads</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <div class="row crm-filter-row-bottom align-items-end">
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Parent Lead Owner</label>                                        
                                        <ReactSelect className="" value={filterparentcaller} onChange={handleFilterParentCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Lead Parent Owner"></ReactSelect>
                                    </div>
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Caller</label>
                                        {/*<select className="form-select" name="leadcaller-filter" onChange={handleFilterCaller} value={filtercaller}>
                                            <option value="">Select Caller</option>
                                            {callers?.map((callerlist) =>
                                                <option key={callerlist.id} value={callerlist.id}>{callerlist.label}</option>
                                            )}

                                        </select>*/}

                                        <ReactSelect className="" value={filtercaller} onChange={handleFilterCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage"></ReactSelect>
                                    </div>
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Stage</label>
                                        <ReactSelect className="" value={filterstage} onChange={handleFilterStage} options={stages} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>


                                    </div>
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Disposition</label>
                                        <ReactSelect className="" value={filterdisposition} onChange={handleFilterDispositon} options={dispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>


                                    </div>
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Program</label>
                                        <ReactSelect className="" value={filterprogram} onChange={handleFilterProgram} options={program} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>

                                    </div>
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Institute</label>
                                        <ReactSelect className="" value={filterinstitute} onChange={handleFilterInstitute} options={institute} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Institute" isMulti></ReactSelect>

                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Source</label>
                                        <ReactSelect className="" value={filtersource} onChange={handleFilterSource} options={sources} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Source" isMulti></ReactSelect>

                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Assignment Type</label>
                                        <ReactSelect className="" value={assignmenttype} onChange={handleFilterAssignmentType} options={assignmenttypelist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Assignment Type"></ReactSelect>


                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Assigned Date</label>
                                        <DatePicker  className="form-control" selected={assignedstartdate} onChange={ handleAssignedDateRange } startDate={assignedstartdate} endDate={assignedenddate} selectsRange isClearable placeholderText="Select assigned date range" />

                                    </div>

                                    
                                </div>

                                <div class="row crm-filter-row-bottom align-items-end">
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Date Range</label>
                                        <select className="form-select" name="date-filter" onChange={handleDateFilterOption} value={datefilteroption}>
                                            <option value="">Select Date</option>
                                            <option value="today">Today</option>
                                            <option value="yesterday">Yesterday</option>
                                            <option value="last7days">Last 7 Days</option>
                                            <option value="last30days">Last 30 Days</option>
                                            <option value="thismonth">This Month</option>
                                            <option value="lastmonth">Last Month</option>
                                            <option value="customdate">Custom Date</option>
                                        </select>
                                    </div>
                                    <div className={ showcustomdates ? 'col-md-12 mb-1' : 'col-md-12 mb-1 d-none'}>
                                        <label class="crm-filter-label">Start Date</label>
                                        <input className="form-control" type="date" name="startdate" placeholder="Start Date" onChange={handleStartDate} value={startdate} />
                                    </div>
                                    <div className={ showcustomdates ? 'col-md-12 mb-1' : 'col-md-12 mb-1 d-none'}>
                                        <label class="crm-filter-label">End Date</label>
                                        <input className="form-control" type="date" name="enddate" placeholder="End Date" onChange={handleEndDate} value={enddate} />
                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Name</label>
                                        <input className="form-control" type="text" name="filtername" onChange={handleFilterName} placeholder="Enter name" value={filtername} />
                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Email</label>
                                        <input className="form-control" type="email" name="filteremail" onChange={handleFilterEmail} placeholder="Enter email" value={filteremail} />
                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Phone</label>
                                        <input className="form-control" type="text" name="filtercontact" onChange={handleFilterContact} placeholder="Enter phone" value={filtercontact} />
                                    </div>
                                </div>

                                <div class="crm-filter-actions">
                                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleLeadFilterModalHide}>Close</button>

                                    <button type="button" className="btn btn-primary me-2" onClick={handleApplyFilter}>
                                            <i className="ti ti-search me-2"></i>Apply Filter
                                    </button>

                                </div>
                            </Offcanvas.Body>
                        </Offcanvas>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="mb-2">
                                <strong>Total Records:</strong> {totalrecords}
                            </div>
                                                       
                            <div className="table-responsive table-wrapper">

                                {loading ?

                                    <ContentLoader />
                                :
                                
                                <table className="table table-data-section" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="checkbox" id="flexCheckDefault" checked={leadids.length > 0 && leadids.length === leads.length} onChange={handleSelectAllLeads} />
                                                    <label class="form-check-label" for="flexCheckDefault"></label>
                                                </div>
                                            </th>
                                            <th className="sortable-column">
                                                Name
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'name' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('name', 'ASC')}></i>
                                                    <i className={ sortby === 'name' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('name', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Email
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'email' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('email', 'ASC')}></i>
                                                    <i className={ sortby === 'email' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('email', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Contact
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'contact' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('contact', 'ASC')}></i>
                                                    <i className={ sortby === 'contact' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('contact', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Location
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'location' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('location', 'ASC')}></i>
                                                    <i className={ sortby === 'location' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('location', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Program
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'program' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('program', 'ASC')}></i>
                                                    <i className={ sortby === 'program' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('program', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Institute
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'institute' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('institute', 'ASC')}></i>
                                                    <i className={ sortby === 'institute' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('institute', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th>Source</th>
                                            <th className="sortable-column">
                                                Call Count
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'callcount' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('callcount', 'ASC')}></i>
                                                    <i className={ sortby === 'institute' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('callcount', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th>Lead Status</th>                                                
                                            <th>Lead Assign</th>
                                            <th className="sortable-column">
                                                Assigned Date
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'assigneddate' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('assigneddate', 'ASC')}></i>
                                                    <i className={ sortby === 'institute' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('assigneddate', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th>Updated Date</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        (leads && leads.length > 0)  ? 
                                            leads?.map(lead => (
                                                
                                                <tr key={lead.id}>
                                                    <td>
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="checkbox" id={'chkleaddata'+lead.id} checked={leadids.includes(lead.id)} onChange={() => handleSelectLead(lead.id)} />
                                                            <label class="form-check-label" for={'chkleaddata'+lead.id}></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Link to={`/team/lead-profile/${lead.id}`} class="">
                                                        {lead.name}
                                                        </Link>
                                                    </td>
                                                    <td>{lead.email}</td>                                                         
                                                    <td>{lead.contact}</td> 
                                                    <td>{lead.location}</td>
                                                    <td>{lead.program}</td>                                                        
                                                    <td>{lead.institute}</td>                                                        
                                                    <td>{lead.source}</td>                                                        
                                                    <td>{lead.callcount}</td>                                                        
                                                    <td>
                                                        {lead.leadstatus ?
                                                            <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                        :
                                                            <span>-</span>
                                                        }
                                                    </td>
                                                    <td>
                                                        {lead.callername}
                                                    </td>
                                                    <td>
                                                        {lead.assigned_at ?
                                                            (moment(lead.assigned_at).format('DD-MM-YYYY h:mm'))
                                                        :
                                                            <>-</>
                                                        }
                                                    </td>
                                                    <td>
                                                        {lead.calleddate ?
                                                            (moment(lead.calleddate).format('DD-MM-YYYY h:mm'))
                                                        :
                                                            (moment(lead.created_at).format('DD-MM-YYYY h:mm'))
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        :
                                            null
                                    }
                                    </tbody>
                                </table>
                                }
                                
                            </div>
                            
                            

                        </div>
                    </div>
                    
                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>

        </div>
    </Layout>
    )
}

export default Lead;
